module.exports = __webpack_public_path__ + "img/johnston_twisp_4074_800.deab7f6d.jpg";